export default {
  onboarding:{
    continueAndConfigure: "Continue",
    startForFree: "Try the best farm management app for free",
    trialPeriod:"You have a 15-day trial, no credit card required.",
    trialPeriodMobile:"Register and configure your farm.",
    yourName:"Your name",
    yourEmail:"Email",
    yourPhone: "Cell phone number for WhatsApp",
    createFieldWithTestData: "Create a field with demo data",
    nameTitle:"Name",
    emailTitle:"Work Email",
    phoneTitle:"Telephone",
    takenEmail: "There is already an account associated with that email",
    costControl: "The costs of your field 100% controlled",
    costInformation: "All your business information in one place in a simple, orderly and real time.",
    allCrops: "Works on all kinds of crops",
  },
  onboarding2:{
    configuration: "Configuration",
    instructions:"Enter the data of your field, try to record most of it to have a better experience.",
    describeYourField: "Describe your field",
    fieldDescription: "Name, location and size",
    headquartersAndHarvest: "Headquarters and Crops",
    yourCostCenter: "Your cost centers",
    workers: "Workers",
    nameAndSalary: "Name and approximate salary",
    supplies: "Supplies",
    suppliesDescription: "Name, quantity and value of the product",
    machineries: "Machineries",
    machineriesDescription: "Name and cost per hour",
    continueWithDemoField:"Continue with demo field",
    noTime: "Don't have time? Use test data",
    createAccount: "Create Account",
    createFieldWithDemoData: "Create field with demo data",
    offlineMode: "Offline Mode Without Internet",
    everywhereYouAre: "Download our app and enter your records from anywhere, no matter where you are",
    syncWhenConnected: "We automatically synchronize your information every time you connect to the internet.",
  },
  onboarding3: {
    access: "Accesses",
    instructions: "Enter a keyword that will allow you to enter the system by web and app.",
    password: "Password",
    passwordPlaceholder: "Key",
    repeatPassword: "Repeat Password",
    repeatPasswordPlaceholder: "Repeat password",
    generatePassword: "Generate password",
    verifyPasswords:"Verify entered passwords",
    passwordDescription:"Password must contain at least one uppercase letter, lowercase letter, one digit and a minimum length of 6 letters.",
    warehouseControl: "Warehouse control and history",
    itemsAndLaborControl: "Control the supplies you use in each job and the purchases made.",
    visualizeItems: "View the traceability of each of your supplies",
  },
  onboarding4: {
    welcome: "Welcome",
    welcomeMessage: "You are ready to enter Agrapp. We leave you a video to understand the use of our web platform and mobile application.",
    storesMessage: "To have a better experience we recommend you download our application in the different stores:",
    contactInfoLabel: "If you want more information about our product, you can write to us via ",
    enterToMyField: "Enter to my farm",
    contactUsViaWa: "Write us via Whatsapp",
    farmerName: "Carlos Silva",
    farmerTestimony: "“Thanks to Agrapp I know exactly how much I am spending on my crops. He has helped me control agricultural work and assistance (of my workers) in a simple (and orderly) way”",
    farmerDescription: "Farmer from Calera de Tango, Chile",
  },
  fieldModal: {
    describeYourField: "Describe your field",
    fieldDescription: "Name, location and size",
    companyName: "Company name",
    companyNamePlaceholder: "Name that identifies your field",
    location: "Location",
    locationPlaceholder: "Commune, region, country",
    size: "Size (ha)",
    sizePlaceholder: "Number of hectares",
  },
  headquarterModal: {
    headquartersAndHarvest: "Headquarters and Crops",
    yourCostCenter: "Your cost centers",
    headquarterName: "Name of the headquarters / Lot",
    headquarterNamePlaceholder: "Name of the field sector",
    crop: "Crop",
    cropPlaceholder: "Crop associated with cost center",
    size: "Size (ha)",
    sizePlaceholder: "Number of hectares",
  },
  workersModal: {
    workers: "Workers",
    nameAndSalary: "Name and approximate salary",
    name: "Name",
    namePlaceholder: "Worker Name",
    approxSalary: "Approximate Salary",
    approxSalaryPlaceholder: "Monthly value",
  },
  suppliesModal: {
    supplies: "Supplies",
    suppliesDescription: "Name, quantity and value of the product",
    productName: "Product name",
    productNamePlaceholder: "Trade name",
    quantity: "Quantity",
    quantityPlaceholder: "Quantity available",
    unitValue: "Unit Value",
    unitValuePlaceholder: "Cost",
    informationTag: "Then you can add more detail to the information of your supplies (type, active ingredient, deficiency, etc.).",
  },
  machineriesModal: {
    machineries: "Machineries",
    machineriesDescription: "Name and cost per hour",
    machineName: "Equipment name",
    machineNamePlaceholder: "Machine name",
    costPerHour: "Cost per Hour",
    costPerHourPlaceholder: "Approximate",
  },
  common: {
    connected: "Connected",
    step:"Step",
    of:"of",
    save: "Save",
    edit: "Edit",
    add: "Add",
    omit: "Omit",
    continue: "Continue",
    generate: "Generate",
    invalidData: "Invalid Information",
    invalidDataDescription: "Please verify the information entered.",
    back:"Back",
  },
  formats: {
    decimalSeparator: ".",
    numberDelimiter: ",",
    middleDateFormat: "MMMM D, YYYY",
    longDateFormat: "dddd, MMMM D, YYYY",
    currencySymbol: "$",
    currencyISO: "USD",
    currencyName: "dollar",
  }, 
  httpErrors:{
    400: "Please verify the information entered",
    401: "Unauthorized",
    403: "Insufficient permissions",
    404: "Resource not found",
    500: "Server Error",
  },
  notFound:{
    notFound: "Not Found",
    routeDoesNotExists: "You just hit a route that doesn't exist...",
    returnToSafePlace: "Return to main page",
  },
};
